export default "__VITE_ASSET__DtpFRCBg__"